import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, createMuiTheme, MuiThemeProvider, Slider, Typography } from '@material-ui/core';

import { getAdminChatTag } from '../../../graphql/queries';
import { marks, valueLabels } from './ChatTagLabelConstant';
import useStyles from './styles';

interface IChatTagActions {
	open: any;
	chatClose: any;
	saveChatTag: any;
	client: any
}


const theme = createMuiTheme({
	overrides: {
		MuiDialog: {
			paperWidthSm: {
				width: '90%',
				overflow: 'hidden'
			},
		},
		MuiDialogContent: {
			root: {
				overflow: 'hidden'
			}
		},
		MuiSlider: {
			marked: {
				'& input + span ': {
					height: '13px',
					marginTop: '-5px',
					backgroundColor: "#3880ff"
				},
				'& input + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span + span': {
					height: '13px',
					marginTop: '-5px',
					backgroundColor: "#bfbfbf"
				}
			},
			markActive: {
				// height: '13px',
				// marginTop: '-5px',
				backgroundColor: "#3880ff"
			},
			mark: {
				// height: '13px',
				// marginTop: '-5px',
				backgroundColor: "#bfbfbf"
			},

			thumb: {
				height: "25px",
				width: "25px",
				backgroundColor: "#fff",
				marginLeft: "-12px",
				marginTop: "-12px",
				boxShadow: "0 3px 1px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.3), 0 0 0 1px rgba(0,0,0,0.02)"
			},
			valueLabel: {
				marginLeft: 12
			},
			track: {
				backgroundColor: "#3880ff"
			}
		}
	}
});


function valuetext(value: any) {
	return `${value}`;
}

const ChatTagActions: React.FC<IChatTagActions> = ({ open, chatClose, saveChatTag, client }) => {
	interface sliderKey {
		[key: string]: any
	}
	const classes = useStyles();
	const [sliderValue, setSliderValue] = useState<sliderKey>({});
	const [sliderLabels, setSliderLabels] = useState<sliderKey>({});
	const [contantData, setcontantData] = useState([]);

	useEffect(() => {
		listDetail();
	}, []);

	const listDetail = async () => {
		// Query using a parameter
		const userMutation = client.query({
			query: getAdminChatTag,
			variables: {
				siteId: process.env.REACT_APP_ACTION_SITEID
			}
		});
		const mutationResponse = await Promise.all([userMutation]);
		let userquerydata = mutationResponse[0].data.getAdminChatTagdataIntlchtbhv.contant;
		const contantMainData = JSON.parse(userquerydata);
		setSliderIntial(contantMainData);
		setcontantData(contantMainData);
	}

	const setSliderIntial = (contantMainData: any) => {
		if (contantMainData.length > 0) {
			let object: sliderKey, objectLabels: sliderKey;
			object = {};
			objectLabels = {};
			for (let index = 0; index < contantMainData.length; index++) {
				const element = contantMainData[index];
				object[Object.keys(element)[0]] = 0;
				objectLabels[Object.keys(element)[0]] = valueLabels[0];
			}
			setSliderValue({ ...object });
			setSliderLabels({ ...objectLabels });
		}
	};

	const handleChange = (event: any, value: any, index: any) => {
		let sliders = sliderValue;
		sliders[`${index}`] = value;
		let slidersText = sliderLabels;
		slidersText[`${index}`] = valueLabels[value / 10];
		setSliderLabels({ ...slidersText });
		setSliderValue({ ...sliders });
	};

	const saveChatTageData = () => {
		let data = { sliderValue, sliderLabels };
		saveChatTag(data);
	};
	function valueLabelFormat(value: any) {
		return marks.findIndex(mark => mark.value === value);
	}

	return (
		<MuiThemeProvider theme={theme}>
			<Dialog
				open={open}
				onClose={() => chatClose()}
				aria-labelledby="form-dialog-title"
				className={classes.chatactionmain}
			>
				<DialogTitle id="form-dialog-title">Chat Tag</DialogTitle>
				<DialogContent>
					<div className={classes.chatAction}></div>
					{contantData && contantData.map((data: any, index: any) => {
						return (
							<div className={classes.chataction}>
								<Typography id="discrete-slider" gutterBottom className={classes.chatTagMain}>
									<span className={classes.chatTagLabel}>
										{Object.keys(data)}
									</span>
									:{' '}
									{sliderLabels[Object.keys(data)[0]]
										? sliderLabels[Object.keys(data)[0]]
										: valueLabels[0]}
								</Typography>
								<Slider
									defaultValue={0}
									name={Object.keys(data)[0]}
									value={sliderValue[Object.keys(data)[0]]}
									getAriaValueText={valuetext}
									valueLabelFormat={valueLabelFormat}
									aria-labelledby="discrete-slider"
									valueLabelDisplay="on"
									step={null}
									marks={marks}
									onChange={(event, value) =>
										handleChange(event, value, Object.keys(data)[0])
									}
								/>
							</div>
						);
					})}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => chatClose()} color="primary" style={{outline:'0'}}>
						Cancel
          	</Button>
					<Button onClick={saveChatTageData} color="primary" style={{outline:'0'}}>
						save changes
          </Button>
				</DialogActions>
			</Dialog>
		</MuiThemeProvider>
	);
};

export default ChatTagActions;